module.exports = __webpack_public_path__ + "static/media/Kessel105-Book.a491abc0.woff";